import React from 'react';
import { IndexPage } from '../../components/pages/IndexPage';
import { useClientContext } from '../../contexts/ClientContext';
import { SecurePage, withUser } from '../../server/withUser';

const Index: SecurePage = ({ businessUnit }: { businessUnit: string }) => {
  const client = useClientContext();
  return (
    <IndexPage
      getMfa={client.mfa(businessUnit)}
      getUser={client.userinfo(businessUnit)}
    />
  );
};

export const getServerSideProps = withUser();

export default Index;
